type WithDefault = {
  default: boolean;
};

export const getDefaultValue = <T extends WithDefault>(
  data: Array<T>
): T | undefined => {
  return data?.find((e) => e.default);
};
